/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Post_Apply_DescriptionInputs */

const ja_careers_post_apply_description = /** @type {(inputs: Careers_Post_Apply_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履歴書と職務経歴書、関連する作品ポートフォリオをご準備ください。`)
};

const en_careers_post_apply_description = /** @type {(inputs: Careers_Post_Apply_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To apply, please send your resume, work history and relevant portfolio of work using this contact form.`)
};

/**
* | output |
* | --- |
* | "To apply, please send your resume, work history and relevant portfolio of work using this contact form." |
*
* @param {Careers_Post_Apply_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const careers_post_apply_description = /** @type {((inputs?: Careers_Post_Apply_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Post_Apply_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_post_apply_description(inputs)
	return en_careers_post_apply_description(inputs)
});